import type { FaireProductEntity } from "../../entity_types/product";

export const p_6meqqhgpaa: FaireProductEntity = {
  token: "p_6meqqhgpaa",
  type: "product",
  name: "Gold Virgin Cross Pendant Necklace in Solid Copper",
  brandToken: "b_xd955m9fpf",
  brandName: "Perimade & Co. LLC",
  imageUrl:
    "https://cdn.faire.com/fastly/e1f77133ebcac7cc5a1a1329f7acce5f4f63b38f01cd06e3cbb8428f5587cf95.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/776704bfc14ca67b4c3c150010807bdb880cce840d2feb6f076affb26e7df9f8.jpeg",
    "https://cdn.faire.com/fastly/aa5272df51d178ffc02a77a4fd9d1f0c0084d7eb31b830194c276e6b65349dcd.jpeg",
    "https://cdn.faire.com/fastly/7c70e9089d25aaf781e8a14cc10e0e8fdd83e3845a282d8ccacace5510732240.jpeg",
    "https://cdn.faire.com/fastly/1369b88d87087826b75cbc3c58523c04b57ae13d53453587c52c2a1eb522b03f.jpeg",
    "https://cdn.faire.com/fastly/debada5011272e01e4c927db19d0d90890e1ba2a5a2c93cb800a44261fedc9d7.jpeg",
    "https://cdn.faire.com/fastly/897859c4807bb64f7662c9629268f680b6cc139487e35bd6a371b5d01aa4ef96.jpeg",
    "https://cdn.faire.com/fastly/569564608611f423639a86b14d3cd8cc73cf097d1ab7d36921cc45ab2777c881.jpeg",
  ],
  priceDollars: 10,
  description:
    "Description & Details\n\nEmbrace the timeless symbol of faith, spirituality, and devotion with our exquisite pieces inspired by the sacred cross. Each design in our collection is meticulously crafted to honor the significance of the cross and serve as a beautiful reminder of one's beliefs and values.\n\n• Material: High Quality Copper ∙ Cubic Zirconia\n• Finish: Hypoallergenic ∙ Gold Plating\n• Dimensions: 29 x 50 mm pendant, 45 - 50 cm chain, adjustable\n• All our work is custom made by hand with love",
  tags: [],
  msrpDollars: 20,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:55:26.126Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
